export const strategies = {
  ignore: () => {},
  collectUnique: targetKey => (acc, key, value) => {
    if (!acc[targetKey]) acc[targetKey] = []

    const exists = acc[targetKey].some(existing => existing?.id === value?.id)

    if (!exists) {
      acc[targetKey].push(value)
    }
  },
  keepFirst: (acc, key, value) => {
    if (!acc[key] && value) {
      acc[key] = value
    }
  },
  booleanOr: (acc, key, value) => {
    acc[key] = acc[key] || value
  },
}

export const mergeConfig = {
  id: strategies.ignore,
  carrier: strategies.collectUnique('carriers'),
  carrier_service: strategies.collectUnique('carrier_services'),
}
